<ng-template #showData>
  <p (click)="isEdit = true">{{value ? value : 'no note'}}</p>
</ng-template>
<mat-form-field *ngIf="isEdit; else showData" class="example-form-field">
  <mat-label>Clearable input</mat-label>
  <input matInput type="text" [(ngModel)]="value">
  <button *ngIf="value" matSuffix mat-icon-button aria-label="Save" (click)="submit()">
    <mat-icon>check</mat-icon>
  </button>
  <button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="isEdit = false">
    <mat-icon>close</mat-icon>
  </button>
</mat-form-field>
